import { BasicBotData, BotType } from "@shared/types";
import { ICON_TYPES } from "@shared/common/constants";
import IconWithFallback from "Global/IconWithFallback";
import React, { CSSProperties } from "react";
import styled, { useTheme } from "styled-components";
import { Manual, TvSymbol, TvSymbolDarkMode } from "common/Icons/Icons";
import { SourceTypeWrapper } from "features/trades/common/IconWithSource";
import Tooltip from "common/Tooltips/Tooltip";

interface BotMainIconProps {
  botData: BasicBotData;
  size?: number;
  iconStyle?: CSSProperties;
  showOneClickDefaultIcon?: boolean;
  isGroupIcon?: boolean;
  showExchangeFallbackIcon?: boolean;
}

const BotMainIcon = ({
  botData,
  size = 32,
  iconStyle,
  showOneClickDefaultIcon,
  isGroupIcon,
}: BotMainIconProps) => {
  const theme = useTheme();
  const isSignalsBot = botData.bot_type === BotType.SIGNAL;
  const isTvBots =
    botData.bot_type === BotType.TRADING_VIEW ||
    botData.bot_type === BotType.TRADING_VIEW_SIGNALS;
  const iconSize = Math.min(size / 2.5, 16);
  const displayOneClickIcon =
    showOneClickDefaultIcon && botData.is_default_one_click;
  const isTvSymbolIcon = isTvBots && !botData.symbols && !isGroupIcon;

  const getImage = () => {
    const finalIconStyle = {
      width: size,
      height: size,
      marginRight: displayOneClickIcon ? 16 : 12,
      borderRadius: 6,
      ...iconStyle,
    };
    if (isTvSymbolIcon) {
      const Icon = theme.isDarkMode ? TvSymbolDarkMode : TvSymbol;
      return <Icon style={finalIconStyle} />;
    }
    return (
      <IconWithFallback
        iconType={
          isSignalsBot || isGroupIcon
            ? undefined
            : isTvSymbolIcon
            ? ICON_TYPES.EXCHANGE
            : ICON_TYPES.COIN
        }
        coinOrExchangeName={
          isSignalsBot || isGroupIcon
            ? undefined
            : isTvSymbolIcon
            ? botData.exchange
            : botData.symbols?.[0]
        }
        iconLink={
          isSignalsBot || isGroupIcon ? botData.sub_group_image : undefined
        }
        iconStyle={finalIconStyle}
      />
    );
  };

  return (
    <Wrapper>
      {getImage()}
      {displayOneClickIcon && (
        <Tooltip title="Is Telegram One-Click Follow default">
          <OneClickIconWrapper>
            <Manual $size={`${iconSize}px`} />
          </OneClickIconWrapper>
        </Tooltip>
      )}
    </Wrapper>
  );
};

export default React.memo(BotMainIcon);

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;
const OneClickIconWrapper = styled(SourceTypeWrapper)`
  position: absolute;
  right: auto;
  left: 45%;
  bottom: 0;
  padding: 3px;
  color: ${(p) => p.theme.colors.primaryBlue};
`;
